export function getCustomizedOption({ columnKey }) {
  switch (columnKey) {
    case 'ChangeAmount':
      return {
        width: 200,
      };
    case 'InsertionOrderDetails':
      return {
        width: 300,
      };
    default:
      return null;
  }
}
